<template>
	<div>
		<ag-grid-vue
			:style="tableStyle"
			class="ag-theme-balham ag_table"
			:class="withBorder ? 'ag-border' : ''"
			id="ag-theme-balham"
			:rowData="realRowData"
			:columnDefs="realL"
			:modules="modules"
			:gridOptions="gridOptions"
			:rowSelection="rowSelection"
			:isRowSelectable="isRowSelectable"
			domLayout="normal"
			:suppressRowClickSelection="suppressRowClickSelection"
			:processCellForClipboard="processCellForClipboard"
			:icons="icons"
			:autoGroupColumnDef="autoGroupColumnDef"
			:detailCellRenderer="detailCellRenderer"
			:detailCellRendererParams="detailCellRendererParams"
			:groupDefaultExpanded="groupDefaultExpanded"
			:frameworkComponents="frameworkComponents"
			:detailRowHeight="detailRowHeight"
			:masterDetail="masterDetail"
			:excelStyles="customExcelStyles"
			@selection-changed="onSelectionChanged"
			@sort-changed="onSortChanged"
			@first-data-rendered="onFirstDataRendered"
			@columnGroupOpened="onColumnGroupOpened"
		></ag-grid-vue>
	</div>
</template>
<script>
import {AllModules} from "@ag-grid-enterprise/all-modules";
import {AgGridVue} from "@ag-grid-community/vue";
import Operation from "./Operation";
import ProspectiveTableOperation from "@/components/templates/seller/prospective/ProspectiveTableOperation.vue";
import IPUView from "./IPUView";
import ColorStatus from "./renderer/ColorStatus";

import CompanyTem from "@/components/templates/agGrid/CompanyTem";
import {mapGetters} from "vuex";

import BiddingAmount from "@/components/templates/investor/exchange/receivables/BiddingAmount";
import BiddingAmountHeader from "@/components/templates/investor/exchange/receivables/BiddingAmountHeader";
import PremiumAmount from "@/components/templates/investor/exchange/revolving/PremiumAmount";
import BiddingBuyButton from "@/components/templates/investor/exchange/receivables/BiddingBuyButton";
import BiddingBuyButtonHeader from "@/components/templates/investor/exchange/receivables/BiddingBuyButtonHeader";
import TCISwitch from "@/components/templates/investor/exchange/receivables/TCISwitch";
import TCISwitchHeader from "@/components/templates/investor/exchange/receivables/TCISwitchHeader";

import PriceInput from "@/components/templates/seller/sell/PriceInput";
import TimePicker from "@/components/templates/seller/sell/TimePicker";
import DurrationSelect from "@/components/templates/seller/sell/DurrationSelect";

import ProgressStatus from "@/components/templates/seller/payments/ProgressStatus";
import PaymentTableOperation from "@/components/templates/seller/payments/PaymentTableOperation";
import GeneralShortenedDisplay from "@/components/templates/agGrid/renderer/GeneralShortenedDisplay";
import ValueWithComparisonSubtext from "@/components/templates/agGrid/renderer/ValueWithComparisonSubtext.vue";
import TimeLeftCountdown from "@/components/templates/agGrid/renderer/TimeLeftCountdown";
import EnumAsText from "@/components/templates/agGrid/renderer/EnumAsText";
import EnumAsTextWithLinkAction from "@/components/templates/agGrid/renderer/EnumAsTextWithLinkAction.vue";
import EnumAsIcon from "@/components/templates/agGrid/renderer/EnumAsIcon";
import BooleanAsIcon from "@/components/templates/agGrid/renderer/BooleanAsIcon";

import BankAccountsTableOperation from "@/components/templates/bankAccount/BankAccountsTableOperation.vue";
import InvoiceOperationRender from "@/components/templates/invoices/InvoiceOperationRender.vue";
import ItemDetail from "./ItemDetail";
import SellTableOperation from "@/components/templates/seller/sell/SellTableOperation";
import DebtorOverviewTableOperation from "@/components/templates/seller/debtorManagement/DebtorOverviewTableOperation";
import SellCurrentTableOperation from "@/components/templates/seller/sell/SellCurrentTableOperation.vue";
import ApplyValue from "@/components/templates/agGrid/renderer/ApplyValue";
import InvestorReceivablePaymentsProgressStatus
	from "@/components/templates/investor/payments/receivables/InvestorReceivablePaymentsProgressStatus";
import AllInvestmentsReceivablesTableOperation
	from "@/components/templates/investor/allInvestments/receivables/AllInvestmentsReceivablesTableOperation";
import AllInvestmentsReceivablesTableCollectionOperation
	from "@/components/templates/investor/allInvestments/receivables/AllInvestmentsReceivablesTableCollectionOperation";
import AllInvestmentsRevolvingPutOptionsTableOperation
	from "@/components/templates/investor/allInvestments/revolving/AllInvestmentsRevolvingPutOptionsTableOperation";
import AllReceivablesTableOperation from "@/components/templates/seller/receivables/AllReceivablesTableOperation";
import AssignmentDetailsRenderer from "@/components/templates/seller/receivables/AssignmentDetailsRenderer";
import DebtorConfirmBtn from "@/components/templates/debtor/DebtorConfirmBtn";
import FileLink from "@/components/templates/agGrid/renderer/FileLink";
import RateReceivableTableOperation from "@/components/templates/seller/sell/RateReceivableTableOperation.vue";
import MultiFileLink from "@/components/templates/agGrid/renderer/MultiFileLink";
import CustomRatingTableOperation
	from "@/components/templates/investor/riskAssessment/customRatings/CustomRatingTableOperation.vue";
import InvestorSellerDebtorConfigTableOperation
	from "@/components/templates/investor/riskAssessment/marketSounding/InvestorSellerDebtorConfigTableOperation.vue";
import OverdueRenderer from "@/components/templates/agGrid/renderer/OverdueRenderer";
import CustomHeader from "@/components/templates/agGrid/header/CustomHeader";
import CustomGroupHeader from "@/components/templates/agGrid/header/CustomGroupHeader";
import ApiKeysTableOperation from "@/views/user/profile/apiKeys/ApiKeysTableOperation";
import DebtorContactTableOperation from "src/components/templates/seller/debtorManagement/DebtorContactTableOperation";
import IntervalRenderer from "src/components/templates/agGrid/renderer/IntervalRenderer";
import CreditsafeRatingRenderer from "@/components/templates/agGrid/renderer/CreditsafeRatingRenderer.vue";
import RevolvingPutOptionTableOperation from "@/components/templates/seller/putOption/RevolvingPutOptionTableOperation";
import RevolvingPutOptionReferenceRenderer
	from "@/components/templates/agGrid/renderer/RevolvingPutOptionReferenceRenderer";
import RevolvingPutOptionSoldReceivablesPaymentStatusRenderer
	from "@/components/templates/modal/revolvingPutOption/RevolvingPutOptionSoldReceivablesPaymentStatusRenderer";
import InvestorPaymentsRevolvingPutOptionsTableOperation
	from "@/components/templates/investor/payments/revolving/InvestorPaymentsRevolvingPutOptionsTableOperation";
import RevolvingPutOptionOffersTableOperation
	from "@/components/templates/seller/putOption/RevolvingPutOptionOffersTableOperation";
import RevolvingPutOptionContractOverviewTableOperation
	from "@/components/templates/seller/putOption/RevolvingPutOptionContractOverviewTableOperation";
import RevolvingPutOptionPremiumPaymentsStatusRenderer
	from "@/components/templates/modal/revolvingPutOption/RevolvingPutOptionPremiumPaymentsStatusRenderer";
import AllInvestmentsRevolvingPutOptionsAssignmentConfirmationsTableOperation
	from "@/components/templates/investor/allInvestments/revolving/AllInvestmentsRevolvingPutOptionsAssignmentConfirmationsTableOperation";
import ReceivableInvestorNoteIcon from "@/components/templates/agGrid/ReceivableInvestorNoteIcon";
import TCIPremium from "@/components/templates/investor/exchange/receivables/TCIPremium";
import ValueOrNotAvailableInWarnColor from "@/components/templates/agGrid/renderer/ValueOrNotAvailableInWarnColor.vue";

// trackpay
import TrackAction from "@/components/templates/trackPay/TrackAction";
import CustomerName from "@/components/templates/trackPay/CustomerName";
import ShipmentProgressStatus from "@/components/templates/trackPay/ShipmentProgressStatus";
import TransferredStatus from "@/components/templates/trackPay/debtor/TransferredStatus";
import ContractStatusScheduled from "@/components/templates/trackPay/ContractStatusScheduled";
import DebtorContractAction from "@/components/templates/trackPay/debtor/DebtorContractAction";
import TrackStatus from "@/components/templates/trackPay/TrackStatus";
import TrackDeviceMark from "@/components/templates/trackPay/TrackDeviceMark";
import {formatAsSingleTextLine} from "@/common/format";

// market sounding
import MarketSoundingDecisionStatus
	from "@/components/templates/investor/exchange/receivables/MarketSoundingDecisionStatus.vue";
import MarketSoundingDecisionTableOperation
	from "@/components/templates/investor/riskAssessment/marketSounding/MarketSoundingDecisionTableOperation.vue";
import MarketSoundingDecisionTableOperationHeader
	from "@/components/templates/investor/riskAssessment/marketSounding/MarketSoundingDecisionTableOperationHeader.vue";
import MarketSoundingDecisionTableMessage from "@/components/templates/investor/riskAssessment/marketSounding/MarketSoundingDecisionTableMessage.vue";
import GeneralActionIconButton from "@/components/templates/agGrid/renderer/GeneralActionIconButton.vue";
import GeneralActionButton from "@/components/templates/agGrid/renderer/GeneralActionButton.vue";
import {DebounceTimer} from "@/common/utils/debounce";

export default {
	components: {
		// eslint-disable-next-line vue/no-unused-components
		CustomHeader,
		// eslint-disable-next-line vue/no-unused-components
		CustomGroupHeader,
		// eslint-disable-next-line vue/no-unused-components
		InvestorReceivablePaymentsProgressStatus,
		// eslint-disable-next-line vue/no-unused-components
		AgGridVue,
		// eslint-disable-next-line vue/no-unused-components
		Operation,
		// eslint-disable-next-line vue/no-unused-components
		ProspectiveTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		ColorStatus,
		// eslint-disable-next-line vue/no-unused-components
		TCISwitchHeader,
		// eslint-disable-next-line vue/no-unused-components
		TCISwitch,
		// eslint-disable-next-line vue/no-unused-components
		TCIPremium,
		// eslint-disable-next-line vue/no-unused-components
		BiddingAmountHeader,
		// eslint-disable-next-line vue/no-unused-components
		BiddingAmount,
		// eslint-disable-next-line vue/no-unused-components
		PremiumAmount,
		// eslint-disable-next-line vue/no-unused-components
		BiddingBuyButton,
		// eslint-disable-next-line vue/no-unused-components
		BiddingBuyButtonHeader,
		// eslint-disable-next-line vue/no-unused-components
		CompanyTem,
		// eslint-disable-next-line vue/no-unused-components
		ValueOrNotAvailableInWarnColor,
		// eslint-disable-next-line vue/no-unused-components
		IntervalRenderer,
		// eslint-disable-next-line vue/no-unused-components
		CreditsafeRatingRenderer,
		// eslint-disable-next-line vue/no-unused-components
		RevolvingPutOptionReferenceRenderer,
		// eslint-disable-next-line vue/no-unused-components
		IPUView, // eslint-disable-next-line vue/no-unused-components
		PriceInput,
		// eslint-disable-next-line vue/no-unused-components
		TimePicker,
		// eslint-disable-next-line vue/no-unused-components
		DurrationSelect,
		// eslint-disable-next-line vue/no-unused-components
		ProgressStatus,
		// eslint-disable-next-line vue/no-unused-components
		PaymentTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		BankAccountsTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		InvoiceOperationRender,
		// eslint-disable-next-line vue/no-unused-components
		GeneralShortenedDisplay,
		// eslint-disable-next-line vue/no-unused-components
		ValueWithComparisonSubtext,
		// eslint-disable-next-line vue/no-unused-components
		GeneralActionIconButton,
		// eslint-disable-next-line vue/no-unused-components
		GeneralActionButton,
		// eslint-disable-next-line vue/no-unused-components
		TimeLeftCountdown,
		// eslint-disable-next-line vue/no-unused-components
		EnumAsText,
		// eslint-disable-next-line vue/no-unused-components
		EnumAsTextWithLinkAction,
		// eslint-disable-next-line vue/no-unused-components
		EnumAsIcon,
		// eslint-disable-next-line vue/no-unused-components
		BooleanAsIcon,
		// eslint-disable-next-line vue/no-unused-components
		ApplyValue,
		// eslint-disable-next-line vue/no-unused-components
		ItemDetail,
		// eslint-disable-next-line vue/no-unused-components
		ReceivableInvestorNoteIcon,
		// eslint-disable-next-line vue/no-unused-components
		SellTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		DebtorOverviewTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		DebtorContactTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		SellCurrentTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		AllInvestmentsReceivablesTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		AllInvestmentsReceivablesTableCollectionOperation,
		// eslint-disable-next-line vue/no-unused-components
		InvestorPaymentsRevolvingPutOptionsTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		AllInvestmentsRevolvingPutOptionsTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		RevolvingPutOptionSoldReceivablesPaymentStatusRenderer,
		// eslint-disable-next-line vue/no-unused-components
		AssignmentDetailsRenderer,
		// eslint-disable-next-line vue/no-unused-components
		AllReceivablesTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		DebtorConfirmBtn,
		// eslint-disable-next-line vue/no-unused-components
		FileLink,
		// eslint-disable-next-line vue/no-unused-components
		RateReceivableTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		MultiFileLink,
		// eslint-disable-next-line vue/no-unused-components
		CustomRatingTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		InvestorSellerDebtorConfigTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		OverdueRenderer,
		// eslint-disable-next-line vue/no-unused-components
		ApiKeysTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		RevolvingPutOptionTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		RevolvingPutOptionOffersTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		RevolvingPutOptionContractOverviewTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		RevolvingPutOptionPremiumPaymentsStatusRenderer,
		// eslint-disable-next-line vue/no-unused-components
		AllInvestmentsRevolvingPutOptionsAssignmentConfirmationsTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		TrackAction,
		// eslint-disable-next-line vue/no-unused-components
		CustomerName,
		// eslint-disable-next-line vue/no-unused-components
		ShipmentProgressStatus,
		// eslint-disable-next-line vue/no-unused-components
		TransferredStatus,
		// eslint-disable-next-line vue/no-unused-components
		ContractStatusScheduled,
		// eslint-disable-next-line vue/no-unused-components
		DebtorContractAction,
		// eslint-disable-next-line vue/no-unused-components
		TrackStatus,
		// eslint-disable-next-line vue/no-unused-components
		TrackDeviceMark,
		// eslint-disable-next-line vue/no-unused-components
		MarketSoundingDecisionStatus,
		// eslint-disable-next-line vue/no-unused-components
		MarketSoundingDecisionTableOperation,
		// eslint-disable-next-line vue/no-unused-components
		MarketSoundingDecisionTableOperationHeader,
		// eslint-disable-next-line vue/no-unused-components
		MarketSoundingDecisionTableMessage,
	},
	props: {
		rowData: Array,
		columnDefs: { type: Array },
		rowSelection: { type: String, default: "multiple" },
		suppressRowClickSelection: { type: Boolean, default: true },
		isRowSelectable: { type: Function, default: null },
		frameworkComponents: Object,
		detailCellRenderer: String,
		detailCellRendererParams: Object,
		groupDefaultExpanded: { type: Number, default: 0 },
		masterDetail: Boolean,
		detailRowHeight: { type: [String, Number], default: 300 },
		minHeight: { type: String, default: "300px" },
		maxHeight: { type: String, default: "" },
		height: { type: String, default: "" },
		heightType: {
			type: [
				String,
				"fillToPageEnd", // Table fills the remaining height until the page end, excluding footer and optionally pagination
				"matchRows", // Table height automatically matches rows, so it adjusts to adding or removing rows
				"fixed" // Fixed height to be set in "height" property
			], default: "fillToPageEnd"
		},
		width: { type: String, default: "100%" },
		withPagination: { type: Boolean, default: true },
		withBorder: { type: Boolean, default: true },
		noTableHeaderClass: { type: Boolean, default: false },
		loadingWarningText: { type: String, default: null },
		excelStyles: { type: Array, default: [] },
		expandedGroups: { type: Array, default: [] },
	},
	data() {
		return {
			calculatedHeight: this.minHeight,
			gridColumnApi: null,
			gridApi: null,
			modules: AllModules,
			icons: {
				sortUnSort: "<i class=\"fa fa-sort\"/>",
				sortAscending: "<i class=\"fa fa-sort-up\"/>",
				sortDescending: "<i class=\"fa fa-sort-down\"/>"
			},
			autoGroupColumnDef: {},
			defaultExcelStyles: [
				{
					id: "header",
					font: {
						bold: true
					}
				},
				{
					id: "headerGroup",
					font: {
						bold: true
					}
				}
			],
			gridOptions: {
				defaultColDef: {
					sortable: false,
					//suppressSizeToFit: true,
					suppressMenu: true,
					menuTabs: [],
					headerComponentFramework: "CustomHeader",
					headerGroupComponentFramework: "CustomGroupHeader"
				},
				defaultExportParams: {
					columnGroups: true,
					processHeaderCallback: (params) => formatAsSingleTextLine(params.column.colDef.headerName)
				},
				unSortIcon: true,
				rowClass: "ag_row",
				localeText: {
					loadingOoo: this.loadingWarningText || this.$t("common.table.loading.msg"),
					noRowsToShow: this.$t("common.table.empty.msg")
				},
				// rowModelType: "serverSide", //无限滚动
				// cacheBlockSize: 50, //fetch 100 rows per at a time
				// maxBlocksInCache: 10,
				animateRows: true,
				rowHeight: 40,
				headerHeight: 40,
				onGridReady: params => {
					// 获取gridApi
					this.gridApi = params.api;
					this.gridColumnApi = params.columnApi;
					this.$emit("getGridApi", this.gridApi);
					this.syncSorting(true);
					// 调整表格列宽大小自适应
					this.showAllColumns(true, this.expandedGroups);
					this.isTofit();
					// this.autoSizeAll();
					// if (this.realL) {
					//   this.realL.forEach(item => {
					//     if (item.sortable) {
					//       params.api.getFilterInstance(item.field);
					//     }
					//   });
					// }
				},
				onGridSizeChanged: params => {
					this.isTofit();

					if (this.heightType === "fillToPageEnd") {
						this.setupHeight();
					}
				},
				onRowSelected: params => {
					this.$emit("row-select", params);
				}
			}
		};
	},
	beforeMount() {
		this.styleColumns();
	},
	methods: {
		setupHeight() {
			if (this.heightType === "fillToPageEnd" && this.$el) {
				let tablePositionTop = this.$el.getBoundingClientRect().top;
				let marginBottom = 5;
				let footerHeight = 45;
				let paginationHeight = this.withPagination ? 42 : 0;
				let offset = tablePositionTop + marginBottom + paginationHeight + footerHeight;

				this.calculatedHeight = `calc(100vh - ${offset}px)`;
			} else if (this.heightType === "matchRows") {
				let headerHeight = this.gridOptions.headerHeight;
				let rowCount = this.realRowData.length;
				let rowHeight = this.gridOptions.rowHeight;
				let adjustmentForPaddingMarginAndBorder = 4;

				this.calculatedHeight = `${headerHeight + adjustmentForPaddingMarginAndBorder + (rowCount * rowHeight)}px`;
			} else if (this.heightType === "fixed") {
				this.calculatedHeight = this.height;
			}
		},
		onSortChanged() {
			this.syncSorting(false);
		},
		syncSorting(initial) {
			const gridSorting = this.gridApi.getSortModel();
			const hasSorting = gridSorting.length > 0;

			if (initial && !hasSorting) {
				return; // No sync necessary
			}

			let backendSorting = gridSorting.map(entry => {
				return {
					columnName: this.gridColumnApi.getColumn(entry.colId).colDef.field,
					direction: entry.sort.toUpperCase()
				};
			});
			this.$emit("sortChanged", backendSorting);
		},
		isTofit() {
			if (this.gridApi) {
				this.gridApi.sizeColumnsToFit();
			}
		},
		onFirstDataRendered(params) {
			/*      params.api.forEachNode(function(node) {
              node.setExpanded();
            });*/
		},
		onSelectionChanged() {
			this.$emit("selectionChanged", this.gridApi.getSelectedRows());
		},
		onColumnGroupOpened() {
			DebounceTimer.debounce("columnGroupOpened", this.isTofit, 10, this);
		},
		getScoll() {
			// document.addEventListener("DOMContentLoaded", function() {
			//   var gridDiv = document.querySelector("#myGrid");
			//   new agGrid.Grid(gridDiv, gridOptions);
			//   agGrid
			//     .simpleHttpRequest({
			//       url:
			//         "https://raw.githubusercontent.com/ag-grid/ag-grid/master/packages/ag-grid-docs/src/olympicWinners.json"
			//     })
			//     .then(function(data) {
			//       // add id to data
			//       var idSequence = 0;
			//       data.forEach(function(item) {
			//         item.id = idSequence++;
			//       });
			//       var server = new FakeServer(data);
			//       var datasource = new ServerSideDatasource(server);
			//       gridOptions.api.setServerSideDatasource(datasource);
			//     });
			// });
		},
		processCellForClipboard(params) {
			let valueFormatter = params.column.colDef.valueFormatter;

			if (!valueFormatter) {
				return params.value;
			}

			let valueFormatterParams = {
				...params,
				colDef: params.column.colDef,
				data: params.node.data
			};

			return valueFormatter(valueFormatterParams);
		},
		autoSizeAll() {
			const allColumnIds = [];
			this.gridColumnApi.getAllColumns()
				.forEach(function(column) {
					allColumnIds.push(column.colId);
				});
			this.gridColumnApi.autoSizeColumns(allColumnIds);
		},
		styleColumns() {
			let hasSingleHeaderRow = this.columnDefs.every(def => !def.children);

			this.columnDefs.forEach((def, index) => {
				this.styleColumn(def, def, index, index, hasSingleHeaderRow);
			});

		},
		styleColumn(columnDef, groupColumnDef, groupIndex, childIndex, hasSingleHeaderRow) {
			if (!columnDef.headerClass) {
				columnDef.headerClass = "";
			}

			if (groupColumnDef.headerClass && groupColumnDef.headerClass.includes("bg_special")) {
				columnDef.headerClass += (groupIndex % 2 === 0 || hasSingleHeaderRow) ? " bg_special_dark" : " bg_special_light";
			} else {
				columnDef.headerClass += this.noTableHeaderClass ? "" : (groupIndex % 2 === 0 || hasSingleHeaderRow) ? " bg_dark" : " bg_light";
			}

			if (childIndex === 0) {
				columnDef.headerClass += " first_in_group";

				if (groupIndex === 0) {
					columnDef.headerClass += " first_child";
				}
			}

			if (columnDef.children) {
				columnDef.children.forEach((child, childIndex) => {
					this.styleColumn(child, groupColumnDef, groupIndex, childIndex, hasSingleHeaderRow);
				});
			}
		},
		showAllColumns(show, groupIds) {
			this.gridColumnApi.getAllDisplayedColumnGroups()
				.forEach((value) => {
					if (value.isExpandable?.() && (!groupIds || groupIds.includes(value.getGroupId()))) {
						this.gridColumnApi.setColumnGroupOpened(value.getOriginalColumnGroup(), show);
					}
				});
		},
	},
	computed: {
		...mapGetters({ upTableData: "upTableData", upTabType: "upTabType" }),
		tableStyle() {
			let width = this.width ? "width: " + this.width + ";" : "";
			let minHeight = this.minHeight ? "min-height: " + this.minHeight + ";" : "";
			let height = "height:" + this.calculatedHeight + ";";
			let maxHeight = this.maxHeight ? "max-height: " + this.maxHeight + ";" : "";

			return width + minHeight + height + maxHeight;
		},
		customExcelStyles() {
			return this.defaultExcelStyles.concat(this.excelStyles);
		},
		realRowData() {
			let r = this.rowData;
			if (r && r.length > 0) {
				r = r.map(item => {
					if (item.currency) {
						item.amountName = this.formatMoney(item.amount) + item.currency;
					}
					if (item.amount) {
						item.amountFormat = this.formatMoney(item.amount);
					}

					if (item.outstanding) {
						item.outstandingName =
							this.formatMoney(item.outstanding) +
							"(" +
							item.outstandingPer +
							")";
					}
					return item;
				});
			}

			return r;
		},
		realL() {
			let c = this.columnDefs;
			if (c) {
				c = c.map(item => {
					item.menuTabs = [];
					item.suppressMovable = true;
					item.comparator = this.dateComparator;
					if (item.children && item.children.length > 0) {
						item.children = item.children.map(cItem => {
							cItem.menuTabs = [];
							cItem.comparator = this.dateComparator;
							return cItem;
						});
					}
					return item;
				});
			}
			return c;
		}
	},
	watch: {
		rowData() {
			this.isTofit();

			if (this.heightType === "matchRows") {
				this.setupHeight();
			}

			// Row data changes trigger a refresh of the table and the selection is reset.
			// For some reason this does not trigger the normal callback, so we do it here.
			// Selection update has to be deferred to waitt until the table is refreshed with the new data.
			this.$nextTick(() => this.onSelectionChanged());
		},
		columnDefs() {
			if (this.gridApi) {
				this.gridApi.setColumnDefs(this.columnDefs);
				this.styleColumns();
				this.isTofit();
			}
		},
	}
};
</script>
